import { Popover, Transition } from '@headlessui/react';
import React from 'react';

export function TransitionPopover({
    open,
    children,
}: {
    open: boolean;
    children: React.ReactNode;
}) {
    return (
        <Transition
            show={open}
            as={React.Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
        >
            <Popover.Panel
                static
                className="absolute z-[400] mt-0 transform w-screen max-w-min left-0"
            >
                {children}
            </Popover.Panel>
        </Transition>
    );
}
